<div class="component-details">
  <fourd-component-header [expert]="expert()" (close)="onClose()"></fourd-component-header>
  <div class="component-column">
    <div class="component-panel manage_card_header">
      <div>
        <h4>Manage Card</h4>
        <ul class="cards-grid">
          <li class="visa">
            <svg><use href="#icon-payment-visa"></use></svg>
          </li>
          <li class="mastercard">
            <svg><use href="#icon-payment-mastercard"></use></svg>
          </li>
        </ul>
      </div>
      <div>
        @if (manageCardLoading) {
        <div class="generic-loader">
          <i><svg><use href="#icon-wait"></use></svg></i>
        </div>
        } @else {
        <div>
          @if (hasRegisteredCard ) {
          <p>You have a saved payment card ({{currentCardNumberPartial}}). To change it please add new card details below.</p>
          } @else {
          <p>You do not have an active payment card, please add details below.</p>
          }
        </div>
        }
      </div>
      <div>
        <p>Your account balance is <span>{{member()?.AvailableBalance?.AmountFormatted}}</span></p>
      </div>
    </div>
    <div class="component-column component-panel">
      @if (product()) {
      <h4>Selected {{resources?.ReadingFirstUpperCase}}</h4>
      <div>
        <fourd-product-display [product]="product()"></fourd-product-display>
      </div>
      }
      @if (manageCardLoading) {
      <div class="generic-loader">
        <i><svg><use href="#icon-wait"></use></svg></i>
      </div>
      }
    </div>
    <div class="component-column component-panel">
      <div>
        @if (manageCardLoading) {
        <div class="generic-loader">
          <i><svg><use href="#icon-wait"></use></svg></i>
        </div>
        }
        @else{
        <div class="component-column">
          <h4>{{hasRegisteredCard?"Change":"Add"}} Card</h4>
          <div [class]="formHelper?.validationSummaryCssClass()">
            <ul>
              @for (error of formHelper?.formErrorMessages(); track error) {
              <li>{{error}}</li>
              }
            </ul>
          </div>
          <div id="card-details-form" class="grid-form" [formGroup]="cardForm">
            <div id="liBillFirstName" class="left-half">
              <div class="input">
                <input type="text" formControlName="First Name" placeholder="First Name" id="txtBillToFirstName" maxlength="60" />
              </div>
            </div>

            <div id="liBillLastName" class="right-half">
              <div class="input">
                <input type="text" formControlName="Last Name" placeholder="Last Name" id="txtBillToLastName" maxlength="60" />
              </div>
            </div>

            <div id="liBillToStreetManual" class="full-width">
              <div class="input">
                <input type="text" formControlName="Street" placeholder="Street" id="txtBillToStreet1" />
              </div>
            </div>

            <div id="liBillCity" class="full-width">
              <div class="input">
                <input type="text" formControlName="City" placeholder="City" id="txtBillToCity" maxlength="50" />
              </div>
            </div>

            <div id="liBillPostalCode" class="left-half">
              <div class="input">
                <input type="text" formControlName="Postcode" placeholder="Postcode" id="txtBillToPostalCode" maxlength="10" />
              </div>
            </div>

            <div id="liBillToCountry" class="right-half">
              <div class="input">
                <select data-lookup="GB,IE" formControlName="Country" id="ddlBillToCountry">
                  <option value="GB">United Kingdom</option>
                  <option value="IE">Ireland</option>
                </select>
              </div>
            </div>

            <div id="liCreditCardType" class="hidden">
              <div class="input">
                <select id="ddlCreditCardType">
                  <option selected="selected" value=""></option>
                  <option value="001">Visa</option>
                  <option value="002">MasterCard</option>
                  <option value="042">Maestro</option>
                </select>
              </div>
            </div>

            <div id="liCardAccountNumber" class="full-width">
              <div class="input">
                <input type="text" class="cardnumber" formControlName="Card Number" placeholder="1234 5678 9012 3456" id="txtCardAccountNumber" maxlength="16" />
              </div>
            </div>

            <div id="liExpiryDate" class="left-half">
              <div id="ExpiryDate" class="inputs">
                <div class="input">
                  <select id="ddlCardExpirationMonth" formControlName="Expiry Month">
                    <option selected="selected" value="">MM</option>
                    <option value="01">01</option>
                    <option value="02">02</option>
                    <option value="03">03</option>
                    <option value="04">04</option>
                    <option value="05">05</option>
                    <option value="06">06</option>
                    <option value="07">07</option>
                    <option value="08">08</option>
                    <option value="09">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                  </select>
                </div>
                <div class="input">
                  <select id="ddlCardExpirationYear" formControlName="Expiry Year">
                    <option selected="selected" value="">YYYY</option>
                    <option value="2025">2025</option>
                    <option value="2026">2026</option>
                    <option value="2027">2027</option>
                    <option value="2028">2028</option>
                    <option value="2029">2029</option>
                    <option value="2030">2030</option>
                    <option value="2031">2031</option>
                    <option value="2032">2032</option>
                    <option value="2033">2033</option>
                    <option value="2034">2034</option>
                    <option value="2035">2035</option>
                    <option value="2036">2036</option>
                    <option value="2037">2037</option>
                  </select>
                </div>
              </div>
            </div>

            <div id="liCardCvNumber" class="clearfix right-half">
              <div class="input">
                <input type="text" formControlName="Card Security Code" placeholder="CVV" class="cardnumber CVV" id="txtCardCvNumber" maxlength="3" />
              </div>
            </div>
          </div>
        </div>
        }
        <div id="card-button">
          <a tabindex="0" class="component-button button-available review-button"
             [class.aspNetDisabled]="submittingData"
             (click)="requestPaymentV2($event)">
            @if (submittingData) {
            <span><i><svg><use href="#icon-wait"></use></svg></i></span>
            } @else {
            <span class="card-button-text">Pay by</span>
            }
            <svg class="visa"><use href="#icon-payment-visa"></use></svg>
            <svg class="mastercard"><use href="#icon-payment-mastercard"></use></svg>
          </a>
        </div>
      </div>

    </div>
  </div>
  @if (modal) {
  <fourd-modal [modal]="modal"></fourd-modal>
  }
  </div>
  @if (paymentExecuting) {
  <div [class]="(modalDialog() ?'displayAsModal-dialog component-container displayAsModal-background':'component-container')">
    <div [class]="(modalDialog() ?'displayAsModal-content component-details paymentIframe-details':'component-details')">
      <a tabindex="0" class="close" (click)="onCloseIframe($event)"><span class="sr-only">close payment iframe window</span><i aria-hidden="true"><svg><use href="#icon-close"></use></svg></i></a>
      <div id="paymentIframe-frameContainer" class="clearfix">
        <iframe id="fourd_payment_frame" height="400" scrolling="no"></iframe>
      </div>
    </div>
  </div>
  }
